import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class LoadingService {

  isLoading = false;

  constructor(
    public loadingController: LoadingController,
    public router: Router
  ) { }

  /**
  * @description  Metodo auxiliar para visualizacion del loading cuando se ejecuten eventos que
  *               requieren de consultar webservicios
  * @param text, para pasarle el texto mientras esta cargando
  * @param spinner, define el tipo de spinner que se va a utilizar
  */
  async present(text: string, spinner) {
    this.isLoading = true;
    return await this.loadingController.create({
      message: text,
      spinner: spinner
      // duration: 2000
    }).then(a => {
      a.present().then(() => {
        console.log('presented');
        if (!this.isLoading) {
          a.dismiss().then(() => console.log('abort presenting'));
        }
      });
    });
  }

  /**
   * @description Metodo para cerrar el loadingController
   */
  async dismiss() {
    this.isLoading = false;
    return await this.loadingController.dismiss().then(() => console.log('dismissed'));
  }
}
